import './vendors';
import './styles/styles.scss';

import ConfigModule from './configs/config-module';
import ConstantsModule from './constants/constants-module';
import DirectivesModule from './directives/directives-module';
import FiltersModule from './filters/filters-module';
import ServicesModule from './services/services-module';

import AdminModule from './modules/admin/admin-module';
import BaseModule from './modules/base/base-module';
import TrainsBaseModule from './modules/trains-base/trains-base-module';
import CarsModule from './modules/cars/cars-module';
import CommonModule from './modules/common/common-module';
import FlightsModule from './modules/flights/flights-module';
import HelpModule from './modules/help/help-module';
import HotelsModule from './modules/hotels/hotels-module';
import LoginModule from './modules/login/login-module';
import MainModule from './modules/main/main-module';
import TrainModule from './modules/train/train-module';
import TripModule from './modules/trip/trip-module';
import UkrailModule from './modules/ukrail/ukrail-module';
import TravellerModule from './modules/traveller/traveller-module';
import AtcModule from './modules/atc/atc-module';
import TemplatesCacheModule from './templates-cache';

const MODULE_NAME = 'app';
const module = angular.module(MODULE_NAME, [
    ...getVendorDependencies(),
    ConfigModule,
    ConstantsModule,
    DirectivesModule,
    FiltersModule,
    ServicesModule,
    AdminModule,
    MainModule,
    BaseModule,
    TrainsBaseModule,
    FlightsModule,
    HotelsModule,
    CarsModule,
    CommonModule,
    TrainModule,
    TravellerModule,
    LoginModule,
    TripModule,
    HelpModule,
    TemplatesCacheModule,
    UkrailModule,
    AtcModule,
]).run(['Analytics', function() { }]);

function getVendorDependencies() {
    return [
        'ngAnimate',
        'ngMessages',
        'ngDropdowns',
        'ngSanitize',
        'ng.deviceDetector',

        'ui.router',
        'ui.router.util',
        'ui.bootstrap',
        'ui.bootstrap.datetimepicker',
        'ui.checkbox',
        'ui.select',
        'uiGmapgoogle-maps',

        'angular-flexslider',
        'angular-google-analytics',
        'mightyDatepicker',
        'nsPopover',
        'slick',
        'vr.directives.slider',
        'checklist-model',
        'LocalStorageModule',
        'credit-cards',
        'ipCookie',
        'rzModule',
    ];
}

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/app.js